export const APP_VERSION = "c4d945a75f2545a76ed614507a8a3a66552c0704";
